import React from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis } from '../../components'
import { useMediaQuery } from '../../hooks'
import { areDatesEqual } from '../../helpers'
import { GraphComponentProps, GraphPayload } from '../../types'

type Props = Pick<GraphComponentProps, 'graphHeight'> & {
  data?: {
    cpc: GraphPayload
    click_per_ad_average: GraphPayload
  }
}

const DoubleClickChart: React.FC<Props> = ({ data, graphHeight }) => {
  const displayType = useMediaQuery()

  const getMonthFormat = () => {
    switch (displayType) {
      case 'mobile':
        return 'one'
      default:
        return 'three'
    }
  }

  const formattedData = data?.cpc?.map(({ date, value }) => ({
    date,
    cpc: Number(value).toFixed(1),
    click: Math.round(
      Number(data?.click_per_ad_average.find(element => areDatesEqual(element.date, date))?.value)
    )
  }))

  const cpcAxisDomain = [
    0,
    Math.round((formattedData ? Math.max(...formattedData.map(({ cpc }) => Number(cpc))) : 0) * 1.3)
  ]

  const clickAxisDomain = [
    0,
    Math.round(
      (formattedData ? Math.max(...formattedData.map(({ click }) => Number(click))) : 0) * 1.1
    )
  ]

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <AreaChart data={formattedData} margin={{ left: -15, top: 0 }}>
        <defs>
          <linearGradient id="color-cpc" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#4DE5B3" stopOpacity={0.2} />
            <stop offset="1" stopColor="#3AF8B9" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color-click" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FC838D" stopOpacity={0.2} />
            <stop offset="1" stopColor="#FC838D" stopOpacity={0} />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: getMonthFormat() })}

        {YAxis({ dataKey: 'cpc', name: 'cpc', unit: '€', domain: cpcAxisDomain })}
        {YAxis({
          dataKey: 'click',
          name: 'click',
          yAxisId: 'click',
          orientation: 'right',
          domain: clickAxisDomain
        })}
        <CartesianGrid stroke="#E0E3EB" strokeDasharray="5 5" />
        {ChartTooltip({ cursor: { stroke: '#292E3D', strokeDasharray: '5 5' } })}
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey="cpc"
          stroke="#1CC089"
          fill="url(#color-cpc)"
          unit="€"
        />
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey="click"
          stroke="#FB606D"
          fill="url(#color-click)"
          yAxisId="click"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default DoubleClickChart
